<script lang="ts">export let size = "20";
const height = size;
</script>

<svg
	{height}
	style="fill: currentColor"
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 28.35 28.35"
	><defs><clipPath id="a"><path fill="none" d="M0 0H28.35V28.35H0z" /></clipPath></defs><g
		clip-path="url(#a)"
		><path
			d="M22.08 11.27h-4.26c-.85 0-1.59-.54-1.86-1.35l-1.32-4.05a.513.513 0 0 0-.64-.33c-.16.05-.28.17-.33.33l-1.32 4.05c-.26.8-1.01 1.35-1.86 1.35H6.23a.507.507 0 0 0-.3.92l3.45 2.5c.68.5.97 1.38.71 2.18l-1.32 4.05c-.09.27.06.56.32.64.16.05.32.02.46-.07l3.45-2.5c.68-.5 1.61-.5 2.29 0l3.45 2.5c.23.17.55.11.71-.11a.5.5 0 0 0 .07-.46l-1.32-4.05c-.26-.8.02-1.69.71-2.18l3.45-2.5c.23-.17.28-.49.11-.71a.521.521 0 0 0-.41-.21Z"
		/><path
			d="M23.59 0H4.76C2.13 0 0 2.13 0 4.76v18.83c0 2.62 2.13 4.76 4.76 4.76h18.83c2.62 0 4.76-2.13 4.76-4.76V4.76c0-2.63-2.14-4.76-4.76-4.76Zm-.35 13.36-3.45 2.5c-.18.13-.25.36-.19.57l1.32 4.05a1.946 1.946 0 0 1-3 2.18l-3.44-2.5a.51.51 0 0 0-.6 0l-3.45 2.5a1.953 1.953 0 0 1-3.01-2.18l1.32-4.05c.07-.21 0-.44-.19-.57l-3.45-2.5a1.962 1.962 0 0 1-.43-2.73c.37-.5.95-.8 1.58-.8h4.26c.22 0 .41-.14.49-.35l1.32-4.05a1.946 1.946 0 0 1 2.46-1.25c.59.19 1.06.66 1.25 1.25l1.32 4.05c.07.21.26.35.49.35h4.26c1.07 0 1.95.87 1.95 1.95 0 .63-.29 1.21-.8 1.59Z"
		/></g
	></svg
>
